import Parsley from 'parsleyjs';
import 'parsleyjs/dist/i18n/ja.js';
import 'parsleyjs/src/extra/validator/comparison.js';
import $ from 'jquery';

const defaultOption = {
  excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden",
  errorsContainer: function(field) {
    return field.$element.closest("[data-parsley-field]") || field.$element.parent()
  }
}
Parsley.setLocale('ja');

const parseDateRequirement = function (requirement) {
  const parsedDate = Date.parse(requirement)
  if (isNaN(parsedDate)){
    const val = $(requirement).val()
    if(val == undefined || val === '') {
      return undefined;
    }
    return Date.parse(val)
  } else {
    return parsedDate;
  }
};

Parsley.addValidator('dateGtNullable', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    if(value == '') {
      return true
    }
    return Date.parse(value) > parseDateRequirement(requirement);
  },
  messages: {
    ja: 'この値は%sより後でないといけません。',
  },
  priority: 32
});

Parsley.addValidator('dateGteNullable', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    if(value == '') {
      return true
    }
    return Date.parse(value) >= parseDateRequirement(requirement);
  },
  messages: {
    ja: 'この値は%sより後でないといけません。',
  },
  priority: 32
});

Parsley.addValidator('dateLt', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    if(parseDateRequirement(requirement) === undefined) {
      return true
    }
    return Date.parse(value) < parseDateRequirement(requirement);
  },
  messages: {
    ja: 'この値は%sより前でないといけません。',
  },
  priority: 32
});

Parsley.addValidator('dateLte', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    if(parseDateRequirement(requirement) === undefined) {
      return true
    }
    return Date.parse(value) <= parseDateRequirement(requirement);
  },
  messages: {
    ja: 'この値は%sより前でないといけません。',
  },
  priority: 32
});

const parsePrice = function(orgVal){
  return Number(orgVal.replace(/,/g, ''))
}

const parseWorkableTime = function(orgVal) {
  return orgVal.match(/(\d+)/)[0];
}

Parsley.addValidator('price', {
  validateString: function (value) {
    const val = parsePrice(value)
    return !!val || val === 0
  },
  messages: {
    ja: '金額を入力してください',
  },
  priority: 32
});

Parsley.addValidator('priceGt', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    const reqVal = ('' + requirement).indexOf('#') === 0 ?
      $(requirement).val() :
      '' + requirement;
    const parsedReqVal = parsePrice(reqVal)
    if(parsedReqVal !== 0 && !parsedReqVal) {
      return true
    }
    return parsePrice(value) > parsedReqVal
  },
  messages: {
    ja: '%sより大きい金額を入力してください。',
  },
  priority: 32
});

Parsley.addValidator('priceGte', {
  requirementType: 'string',
  validateString: function (value, requirement) {
    const reqVal = ('' + requirement).indexOf('#') === 0 ?
      $(requirement).val() :
      '' + requirement;
    const parsedReqVal = parsePrice(reqVal)
    if(parsedReqVal !== 0 && !parsedReqVal) {
      return true
    }
    return parsePrice(value) >= parsedReqVal
  },
  messages: {
    ja: '%s以上の金額を入力してください。',
  },
  priority: 32
});

Parsley.addValidator('selectGte', {
  validateString: function (value, requirement) {
    const options = $(requirement + " option").map((i, ele) => {
      return ele.value;
    }).get();
    const reqVal = $(requirement).val();
    const valueIndex = options.indexOf(value);
    const reqValIndex = options.indexOf(reqVal);
    return valueIndex >= reqValIndex;
  },
  messages: {
    ja: '%sより大きい値を入力してください。',
  },
  priority: 32
})

export function formValidator(formElement, option) {
  const applyOption = Object.assign({}, defaultOption, option)
  return new Parsley.Factory(formElement, applyOption);
}
